import React from "react";
import { ShieldCheck, Users, Clock, BadgeCheck } from "lucide-react";

const items = [
  {
    icon: ShieldCheck,
    title: "Confidential & Secure",
    desc: "Your information is handled with strict confidentiality and professional care.",
  },
  {
    icon: Users,
    title: "Dedicated Relationship Support",
    desc: "We guide you end-to-end — eligibility, documents, offers and approvals.",
  },
  {
    icon: Clock,
    title: "Faster Processing",
    desc: "Structured applications + right lender match to reduce rejections and delays.",
  },
  {
    icon: BadgeCheck,
    title: "Premium Advisory Approach",
    desc: "Not a call-center. We focus on best-fit solutions and long-term relationships.",
  },
];

export default function WhyOjovest() {
  return (
    <section className="py-12">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-[#222]">Why OJOVEST?</h2>
        <p className="mt-2 text-[#555] max-w-2xl">
          A premium, advisory-first experience for loans, credit cards and wealth solutions.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <div
                key={idx}
                className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm"
              >
                <div className="w-12 h-12 rounded-xl bg-[#F8F4EF] flex items-center justify-center">
                  <Icon className="text-[#354F37]" size={22} />
                </div>
                <h3 className="mt-4 font-bold text-[#222]">{it.title}</h3>
                <p className="mt-2 text-sm text-[#555]">{it.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
